// extracted by mini-css-extract-plugin
module.exports = {"shortnews-wrapper":"styles-m__shortnews-wrapper__2iWVA","logo-div":"styles-m__logo-div__Dosda","content":"styles-m__content__3WxhZ","link":"styles-m__link__yxGVX"};